import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectLabel } from '../../../../flux/selectors/i18n'
import { selectProduct } from '../../../../flux/selectors/product'
import { uxEvent } from '../../../../flux/actions/ux'
import { selectHideProductsTitles } from '../../../../flux/selectors/layout'
import ProductDetail from './ProductDetail'
import { selectCollectionProductsList } from '../../../../flux/selectors/products'
import { selectCurrentCollectionIndex } from '../../../../flux/selectors/ux'
import formatPrice from '../../../../helpers/formatPrice'

const ProductDetailController = ({
  productId,
  descriptionLabel,
  hideProductsTitle,
  name,
  sale,
  price,
  prefixPrice,
  suffixPrice,
  customLabel,
  discountedPrice,
  description,
  onSeeMoreClick,
  availability,
  pagination,
  containerRef,
}) => (
  <ProductDetail
    productId={productId}
    descriptionLabel={descriptionLabel}
    hideProductsTitle={hideProductsTitle}
    name={name}
    sale={sale}
    price={price}
    prefixPrice={prefixPrice}
    suffixPrice={suffixPrice}
    customLabel={customLabel}
    discountedPrice={discountedPrice}
    description={description}
    onSeeMoreClick={onSeeMoreClick}
    availability={availability}
    pagination={pagination}
    containerRef={containerRef}
  />
)

ProductDetailController.propTypes = {
  product: PropTypes.shape({}).isRequired,
  productId: PropTypes.string.isRequired,
  descriptionLabel: PropTypes.string,
  hideProductsTitle: PropTypes.bool,
  availability: PropTypes.string,
  pagination: PropTypes.string,
  name: PropTypes.string,
  sale: PropTypes.string,
  price: PropTypes.string,
  prefixPrice: PropTypes.string,
  suffixPrice: PropTypes.string,
  customLabel: PropTypes.string,
  discountedPrice: PropTypes.string,
  description: PropTypes.string,
  onSeeMoreClick: PropTypes.func.isRequired,
  containerRef: PropTypes.shape({}),
}

ProductDetailController.defaultProps = {
  descriptionLabel: '',
  hideProductsTitle: false,
  availability: '',
  pagination: '',
  name: '',
  sale: '',
  price: '',
  prefixPrice: '',
  suffixPrice: '',
  customLabel: '',
  discountedPrice: '',
  description: '',
  containerRef: null,
}

const mapStateToProps = (state, { productId }) => {
  const product = selectProduct(productId)(state)
  if (!product) return {}

  const {
    title,
    description,
    settings: {
      availability,
      starting_price: startingPrice,
      price_extended: priceExtended,
      price_prefix: prefixPrice,
      price_suffix: suffixPrice,
      sale,
      custom_label_1,
    },
  } = product

  const price = formatPrice(priceExtended?.digits, priceExtended?.currency_symbol)
  const discountedPrice = formatPrice(startingPrice?.digits, startingPrice?.currency_symbol)

  const products = selectCollectionProductsList(state)
  const collectionIndex = selectCurrentCollectionIndex(state)

  const pagination = `${collectionIndex + 1}/${products.length}`
  const hideProductsTitle = selectHideProductsTitles(state)

  return {
    productId,
    hideProductsTitle,
    descriptionLabel: selectLabel('description')(state),
    name: title,
    sale: sale || '',
    price,
    prefixPrice: prefixPrice || '',
    suffixPrice: suffixPrice || '',
    customLabel: custom_label_1 || '',
    discountedPrice,
    description,
    availability,
    pagination,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSeeMoreClick: isCollapsed => {
    dispatch(uxEvent({
      name: 'click',
      target: 'ProductDetail/SeeMore',
      params: { productId: ownProps.productId, isCollapsed },
    }))
  },
})

ProductDetail.displayName = 'ProductDetail'
ProductDetail.whyDidYouRender = true

export default connect(mapStateToProps, mapDispatchToProps)(
  React.memo(ProductDetail),
)
